module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Family members provide most of the care for persons with Alzheimer’s disease and other forms of dementia. As symptoms such as forgetfulness, confusion, and personality changes take place, caregivers are left to grieve for a loved one who is physically present yet relationally disappearing. Research has shown that adult children caring for parents often report a deep sense of loneliness and increased conflict with other family members."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn_1",
      "id": "fn-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Many spousal caregivers of Alzheimer’s patients struggle to make sense of their marriage as the disease progresses."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn_2",
      "id": "fn-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During times of confusion and anxiety, many caregivers turn to their religious faith or spirituality as a means of coping."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn_3",
      "id": "fn-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" However, most places of worship are not well equipped to address the impact of dementia on families. Current literature shares that caregivers often feel isolated from others; this includes feeling isolated from their church."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn_4",
      "id": "fn-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" A person is diagnosed with Alzheimer’s disease every 65 seconds."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn_5",
      "id": "fn-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" With communities supporting an increasing number of aging citizens, it only makes sense that our places of worship would become centers of support for persons with dementia and their family members.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One evening before going to bed I posted this question on a Facebook dementia caregiving page: “What would you want your church to know about your experience as a dementia caregiver?” When I woke up the next morning, there were 260 responses, and some were entire paragraphs. In sharing their needs, most responders yearned for their church to provide better support. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Finding Sanctuary in the Midst of Alzheimer’s")]), _vm._v(" is a ministry that helps to fill this void for caregivers who are searching for spiritual support. It also equips congregations with the tools and direction they need to provide better support to caregivers in their communities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This curriculum is a Bible study rooted in Scripture and framed by the personal experiences of caregivers. The Personal Narratives within this study were gathered from my doctoral research, my work as a hospice chaplain, and interactions with others on various dementia caregiver support groups on Facebook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This program is meant to offer hope and prompt meaningful discussion. While I have used the Bible as the spiritual context, I hope that people of all backgrounds will benefit from this ministry and from the assurance that there is a higher power overseeing, loving, and providing a sense of meaning, regardless of your faith background.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ultimately, I pray that these pages bring you encouragement, strength, and newfound meaning for your journey.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 75
// module chunks = 0